import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { showToast } from '../common/Toast';

const Register = () => {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    password: '',
    organization: '',
    country: '',
    role: 'Chercheur',
    newsletter: true,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) navigate('/mon-compte');
  }, [user, navigate]);

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await register(formData);
      showToast('Compte créé avec succès !');
      navigate('/abonnements?welcome=1');
    } catch (err) {
      setError(err.message);
      showToast(err.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section" style={{ paddingTop: '56px' }}>
      <div className="container">
        <div className="text-center" style={{ marginBottom: '36px' }}>
          <span className="section-kicker" style={{ justifyContent: 'center' }}>
            Bienvenue
          </span>
          <h1 className="section-title">Créer votre compte AEII</h1>
          <p className="section-lead" style={{ margin: '0 auto' }}>
            Votre compte est créé gratuitement avec la formule <strong>Gratuit</strong>.
            Vous pourrez ensuite passer à une formule Classique ou Premium à tout moment.
          </p>
        </div>

        <div className="form-card">
          {error && <div className="form-msg error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="full_name">Nom complet *</label>
                <input
                  type="text"
                  id="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Adresse email *</label>
                <input
                  type="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="organization">Organisation / institution</label>
                <input
                  type="text"
                  id="organization"
                  value={formData.organization}
                  onChange={handleChange}
                  placeholder="Université, entreprise, ministère..."
                />
              </div>
              <div className="form-group">
                <label htmlFor="country">Pays</label>
                <input
                  type="text"
                  id="country"
                  value={formData.country}
                  onChange={handleChange}
                  placeholder="Ex : Sénégal"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="role">Profil</label>
                <select id="role" value={formData.role} onChange={handleChange}>
                  <option value="Chercheur">Chercheur</option>
                  <option value="Étudiant">Étudiant</option>
                  <option value="Entreprise">Entreprise</option>
                  <option value="Institution publique">Institution publique</option>
                  <option value="Journaliste">Journaliste</option>
                  <option value="Consultant">Consultant</option>
                  <option value="Autre">Autre</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="password">Mot de passe *</label>
                <input
                  type="password"
                  id="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength="6"
                />
              </div>
            </div>

            <div className="form-group">
              <label className="checkbox-line">
                <input
                  type="checkbox"
                  id="newsletter"
                  checked={formData.newsletter}
                  onChange={handleChange}
                />
                Je souhaite recevoir les publications et actualités de l'AEII par email
              </label>
            </div>

            <button type="submit" className="btn btn-dark btn-block" disabled={loading}>
              {loading ? 'Création en cours...' : 'Créer mon compte gratuit'}
            </button>
          </form>

          <p className="auth-switch">
            Vous avez déjà un compte ? <Link to="/connexion">Connectez-vous</Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Register;